/* ==========================================================================
   C6 · K2 · LA SURCOUCHE DE RECHERCHE EST UNE SURCOUCHE COMME LES AUTRES
   --------------------------------------------------------------------------
   Relevé de Raph, le 02/09 : « les suggestions marchent bien sur accueil et
   fiche mais sur page de collection quand t'ouvres la loupe le comportement
   n'est pas le même. »

   CE QUE LA RECETTE A TROUVÉ, ET CE QU'ELLE A ÉCARTÉ.
   Onze pages mesurées en 390 × 844 (`c6-v4-loupe.mjs`), du haut de page et
   page descendue. L'overlay s'ouvre, le champ prend le focus, le panneau
   est visible et la fermeture rend la page : IDENTIQUEMENT sur les onze,
   collection comprise. Trois suspects du cahier sont donc écartés, chiffres
   à l'appui :

     · LA BARRE COLLANTE DE C3 ne recouvre rien : `elementFromPoint` au
       centre du champ répond « champ » sur les cinq visages de la
       collection comme sur l'accueil.
     · L'EN-TÊTE QUI SE CACHE ne fausse pas la hauteur du panneau. C'était
       le suspect le plus sérieux, parce que `PredictiveSearch.onFocus` lit
       `header.getBoundingClientRect().bottom` UNE SEULE FOIS et l'écrit sur
       `<html>` - la mécanique exacte du défaut B8 de la vague 3. Mesuré sur
       une collection descendue à 1200 : en-tête à 40 px au moment de
       l'appui, `--header-bottom-position` posé à 156, débordement 0. Le
       bouton de l'en-tête attend 100 ms avant de donner le focus, et
       l'en-tête a fini de revenir.
     · LE `predictive-search` NE MANQUE PAS du document de la collection :
       un exemplaire, promu, sur les onze pages.

   LA VRAIE CAUSE, ET ELLE N'EST PAS DANS LA COLLECTION.
   La surcouche de recherche est la SIXIÈME surface plein écran du site -
   après le lecteur vidéo, la feuille de filtres, la mini-fiche, le tiroir
   panier et le tiroir de navigation - et la SEULE à qui la politique
   `cm-over` de `casemira-tokens.css` n'a jamais été appliquée. Elle bloque
   pourtant le défilement de la page (`body.search-open { overflow: hidden }`)
   et couvre l'écran : c'est bien une surcouche.

   Conséquence, relevée au point : panneau ouvert sur une collection, à
   mi-hauteur du panneau, ce qui répond au doigt est
   `csm-cookie-consent.csm-cmp-root` - le bandeau de consentement, un élément
   à racine fantôme posé en `position: fixed` avec un `z-index` de
   2 147 483 647. Et la pastille de chat est rendue visible par-dessus, à
   570 px, c'est-à-dire au milieu des résultats.

   POURQUOI ÇA SE VOIT SURTOUT SUR UNE COLLECTION, ET C'EST UNE HISTOIRE DE
   TEMPS PASSÉ, PAS DE GABARIT. Les deux flottants n'apparaissent pas à
   l'arrivée : le bandeau attend le premier geste, la pastille de chat se
   montre après quelques secondes et un défilement. Un visiteur qui ouvre la
   loupe en arrivant sur l'accueil les précède ; celui qui a parcouru une
   collection, descendu, remonté, puis cherché, les a tous les deux devant
   ses résultats. C'est le même défaut sur toutes les pages, et il ne se
   déclenche que là où le visiteur reste - ce qui est exactement ce que Raph
   décrit.

   LA RÉPARATION EST CELLE QUI EXISTE DÉJÀ. On n'écrit aucune règle neuve et
   on ne touche ni à `casemira-tokens.css` (vague 11 du panier), ni à
   `theme.css`, ni à `search.js` : on pose la classe `cm-over` sur `<html>`
   pendant que la surcouche vit, comme le tiroir de navigation le fait depuis
   la vague 2. Le bandeau et la pastille reviennent intacts à la fermeture -
   le consentement n'est ni pris, ni contourné, ni présumé.

   ON SUIT `body.search-open`, ET PAS UN ÉVÈNEMENT À NOUS. C'est l'état
   d'autorité de `PredictiveSearch` : il le pose dans `onFocus` et le retire
   dans `toggleSearchState`, y compris quand le tiroir de navigation s'ouvre
   par-dessus. Un observateur de mutation le lit sans rien lui demander.

   ON NE RETIRE PAS `cm-over` SI QUELQU'UN D'AUTRE LA REVENDIQUE. La classe
   est partagée par cinq surcouches. Si le tiroir de navigation est ouvert au
   moment où la recherche se ferme - ce qui arrive, puisque ouvrir le tiroir
   FERME la recherche - la retirer éteindrait la protection du tiroir et
   ferait réapparaître le bandeau par-dessus lui. On ne retire donc que ce
   qu'on a posé, et seulement si plus personne ne la tient.

   Ce fichier ne contient AUCUN texte affichable.
   ========================================================================== */
(function () {
  'use strict';

  var posePar = false;

  /* LES DEUX SEULS AUTRES REVENDICATEURS, NOMMÉS UN PAR UN.
     Une première version visait large (`.drawer[open], details-modal[open]`)
     et c'était une faute : la fenêtre d'inscription porte elle aussi la
     classe `drawer`, si bien que `cm-over` RESTAIT posée après la fermeture
     de la recherche - et le bandeau de consentement avec elle, effacé sans
     que rien ne le rende. Un bandeau de consentement qu'on oublie d'éteindre
     est un défaut ; un bandeau qu'on oublie de RALLUMER en est un autre, et
     il est plus grave.

     On ne nomme donc que ce qui pose réellement `cm-over` aujourd'hui :
       · le tiroir de navigation, par `casemira-c6-tiroir.js`, tant que
         `<menu-drawer>` porte `open` ;
       · le tiroir panier, par `casemira-cart.js`, qui marque `<html>` de
         `cmk-open` pendant tout le temps où il vit ;
       · le guide des tailles des fiches couloir, par
         `casemira-guide-tiroir.js`, qui marque `<html>` de `cmg-lock` de son
         ouverture à la fin de sa transition de sortie (ajout C5, 05/09) ;
       · la mini-fiche des collections, par `casemira-collection-plus.js`, qui
         marque `<html>` de `cmq-locked` tant que la feuille vit (ajout C5,
         05/09 : la recherche prédictive et la grille cohabitent sur une page
         de collection, et fermer la recherche par-dessus une mini-fiche
         ouverte rallumait le bandeau).
     Le lecteur vidéo passe par `csm-video-open`, qui a sa propre paire de
     règles dans les tokens : il n'est pas concerné. */
  function quelquUnDAutreLaTient() {
    return (
      document.documentElement.classList.contains('cmk-open') ||
      document.documentElement.classList.contains('cmg-lock') ||
      document.documentElement.classList.contains('cmq-locked') ||
      /* `cmt-lock` : le guide des tailles des fiches HORS couloir (`casemira-guide-tailles.js`, ajout R5, 05/09). */
      document.documentElement.classList.contains('cmt-lock') ||
      !!document.querySelector('menu-drawer[open]')
    );
  }

  function applique() {
    var ouvert = document.body.classList.contains('search-open');
    if (ouvert) {
      document.documentElement.classList.add('cm-over');
      posePar = true;
      return;
    }
    if (posePar && !quelquUnDAutreLaTient()) {
      document.documentElement.classList.remove('cm-over');
    }
    posePar = false;
  }

  /* ══════════════════════════════════════════════════════════════════════════
     R1 · UNE SURCOUCHE À LA FOIS, ET C'EST LE TIROIR QUI S'EFFACE
     --------------------------------------------------------------------------
     Relevé de Raph, le 03/09 au matin : « quand tu ouvres le méga-menu mobile
     et qu'ensuite tu ouvres la loupe : sur l'accueil et sur une fiche, le
     comportement est parfait ; sur une page de collection ça ne propose
     rien ».

     CE QUI SE PASSAIT, MESURÉ (`c6-v6-diag.mjs`, Chromium ET WebKit, réseau
     bridé, cache vide, appui à 1 s, 3 s et 8 s) : le panneau de recherche
     s'ouvrait correctement PARTOUT - 508 px de haut, huit produits
     recommandés, dix suggestions à la frappe de « g », sur les trois
     gabarits et dans les deux moteurs. Il était simplement PEINT DESSOUS le
     tiroir de navigation resté ouvert. Sur les six points relevés à la
     verticale du panneau, ce qui répondait au doigt sur une collection était
     `div.cmt-racc`, `div.cmt-portes`, `span.cmt-rang__t` : le tiroir. Sur
     l'accueil et sur la fiche, les six répondaient « panneau ».

     POURQUOI LA COLLECTION, ET ELLE SEULE. Les paliers de profondeur relevés
     par CDP :

       élément            accueil / fiche     collection
       menu-drawer        1                   300
       .header__top       2                   2
       en-tête (section)  30                  200

     La règle qui les élève est écrite dans `assets/casemira-collection.css`
     et elle a raison de l'être : sur les pages qui portent la barre de
     filtres collante (`body:has(.cmc-host)`), les surcouches du thème
     remontent au palier `--z-drawer` (300) pour passer devant elle. Son
     commentaire dit même que « le tiroir de menu, le panier ET LA RECHERCHE
     en héritent ».

     Ils n'en héritent pas tous. La règle vise `.drawer` et `.modal`, les deux
     classes du thème ; or la surcouche de recherche est `.header__search`,
     qui ne porte ni l'une ni l'autre - elle vit dans `.header__top`, à
     `z-index: 2`. Sur une collection, le tiroir monte à 300 et la recherche
     reste à 2 : le panneau existe, il est rempli, il est simplement derrière.
     Ailleurs, le tiroir vaut 1 et la recherche 2 : le même code donne
     l'ordre inverse. UN SEUL PIXEL DE FEUILLE SÉPARE LES DEUX COMPORTEMENTS.

     LA RÉPARATION N'EST PAS UN PALIER DE PLUS. Empiler des `z-index` pour
     départager deux surfaces plein écran, c'est écrire le prochain défaut :
     la troisième surface arrivera. DESIGN.md § « Une Surcouche à la Fois »
     dit ce qu'il faut faire, et le thème l'applique déjà DANS L'AUTRE SENS -
     `search.js` ferme la recherche quand le tiroir s'ouvre. On rend la règle
     SYMÉTRIQUE : la recherche qui s'ouvre ferme le tiroir, par la méthode du
     thème (`hide()`), sans en réécrire une seconde.

     Une ceinture de feuille accompagne, dans `casemira-c6-tiroir.css` : tant
     que la recherche est ouverte, sa boîte passe au-dessus du palier des
     tiroirs. Elle ne sert que le jour où les deux vivraient quand même
     ensemble - une navigation ajax, un rendu d'éditeur - et elle ne coûte
     rien le reste du temps.
     ══════════════════════════════════════════════════════════════════════════ */
  function ecarteLeTiroir() {
    if (!document.body.classList.contains('search-is-open') &&
        !document.body.classList.contains('search-open')) return;
    var t = document.querySelector('menu-drawer[open]');
    /* `hide()` est la méthode du composant du thème : elle rend le focus,
       joue la transition, retire `open` et laisse `casemira-c6-tiroir.js`
       remettre la pile d'écrans à la racine. On ne touche pas à l'attribut à
       la main : un tiroir fermé de force garderait son `inert` et son voile. */
    if (t && typeof t.hide === 'function') t.hide();
  }

  if (!('MutationObserver' in window)) return;
  new MutationObserver(function () {
    applique();
    ecarteLeTiroir();
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
  applique();
  ecarteLeTiroir();

  /* ══════════════════════════════════════════════════════════════════════════
     N1 · LE RATTRAPAGE DE CE QUI A ÉTÉ FAIT AVANT NOUS
     --------------------------------------------------------------------------
     Depuis la vague 5, la loupe de l'en-tête répond dès qu'elle est peinte :
     son branchement n'attend plus `DOMContentLoaded`, qui arrive à 17 s sur
     une page de collection d'un téléphone ordinaire (mesure en tête du bloc
     de `sections/header.liquid`). La surcouche s'ouvre donc, et les
     « produits les plus recherchés » - rendus par Liquid, déjà dans le
     document - s'affichent tout de suite.

     Reste ce que ce fichier seul peut réparer : `PredictiveSearch` branche
     `focus` et `input` DANS SON CONSTRUCTEUR, c'est-à-dire à la promotion de
     l'élément, quand `search.js` s'exécute. Un visiteur qui a ouvert la loupe
     et tapé AVANT cet instant a un champ rempli que personne n'a écouté : la
     frappe est perdue, et il faudrait qu'il tape une lettre de plus pour que
     quelque chose parte. C'est exactement le « je tape et rien ne se passe ».

     On rejoue donc, une seule fois, ce que le composant a manqué :
     le `focus` (qui ouvre le panneau et pose `search-open`) et, s'il y a déjà
     du texte, l'`input` (qui déclenche la requête de suggestion). Les deux
     évènements sont ceux du composant, pas les nôtres : on ne lui demande
     rien qu'il ne sache déjà faire.

     Ce fichier est chargé en `defer` APRÈS `search.js` : quand il s'exécute,
     `predictive-search` est promu. `whenDefined` n'est là que pour le jour où
     l'ordre changerait, et il ne résout jamais si `search.js` ne charge pas -
     auquel cas il n'y a rien à rattraper. */
  if (!window.customElements || !customElements.whenDefined) return;
  customElements.whenDefined('predictive-search').then(function () {
    if (!document.body.classList.contains('search-is-open')) return;
    var champ = document.querySelector('.header__search input[type="search"]');
    if (!champ) return;
    if (document.activeElement !== champ) champ.focus();
    /* `focus` ne remonte pas : l'écouteur du composant est posé sur le champ
       lui-même, un évènement non bouillonnant l'atteint. */
    champ.dispatchEvent(new Event('focus'));
    if (champ.value.trim().length) champ.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
